import React, { useEffect } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import { connect } from "react-redux";

let playerIsLoaded = false;
const sldpPlayers = [];

const StreamMultiroom = ({ user }) => {
  useEffect(() => {
    const loadPlayerScript = async () => {
      if (!playerIsLoaded) {
        const script = document.createElement("script");
        script.src = "/sldp-v3.1.1.min.js";
        script.async = true;
        script.onload = scriptLoaded;

        document.body.appendChild(script);
      }
    };

    const scriptLoaded = async () => {
      if (!playerIsLoaded) {
        
        playerIsLoaded = true;
        const body = document.body;
        let height = 600;
        if (window.innerHeight) {
          height = window.innerHeight;
        } else if (body.parentElement.clientHeight) {
          height = body.parentElement.clientHeight;
        } else if (body && body.clientHeight) {
          height = body.clientHeight;
        }

        const token = localStorage.getItem("session");
        const headers = {
          "Content-Type": "application/json",
          Authorization: "Basic " + token,
        };
                 for (let i = 0; i < user.streams.length; i++) {
           try {
            if(user.streams[i].type = "single"){
              const res = await axios.get("streams/url", { headers });
              const url = res?.data?.authsig;
              const player = window.SLDP.init({
                container: `player-wrp-${i + 1}`,
                stream_url: user.streams[i].streamURL + url,
                buffering: 800,
                autoplay: true,
                muted: true,
                height: (height - 150) / 2,
              });


              sldpPlayers[i] = player;
              const playerWrapper = document.getElementById(`player-wrp-${i + 1}`).parentElement;
              playerWrapper.style.alignItems = "center";
              playerWrapper.style.justifyContent = "center";
            }
          } catch (error) {
            console.log("Error loading stream");
          }
        }

      }
    };

    loadPlayerScript();

    return () => {
      console.log("Component unmounted");
    };
  }, [user.streams]);


  return (
    <Box>
      <Box 
        display="flex" 
        alignItems="center" 
        flexWrap="wrap"
        gap={2}
      >
        {user.streams?.map((stream, index) => (
          <Box 
            key={index} 
            sx={{ 
              minWidth: 100, 
              alignItems: "center", 
              justifyContent: "center",
              flex: 1,
              minWidth: '300px'
            }}
          >
            <div id={`player-wrp-${index + 1}`} className="player-wrp"></div>
          </Box>
        ))}
      </Box>
    </Box>
  );
  };

export default connect((state) => ({ user: state.auth.user }))(StreamMultiroom);